
import fs from 'fs';

const loadHelp_main = function(){
  return new Promise(function(resolve, reject){
    helpModal.innerHTML = fs.readFileSync(__dirname + '/../markUp/helpModal/_help-main.html', 'utf8');
    resolve();
  });
}
const loadHelp_header = function(){
  return new Promise(function(resolve, reject){
    helpHeader.innerHTML = fs.readFileSync(__dirname + '/../markUp/helpModal/help-header.html', 'utf8');
    resolve();
  });
}
const loadHelp_body = function(){
  return new Promise(function(resolve, reject){
    helpBody.innerHTML = fs.readFileSync(__dirname + '/../markUp/helpModal/help-body.html', 'utf8');
    resolve();
  });
}
const loadHelp_footer = function(){
  return new Promise(function(resolve, reject){
    helpFooter.innerHTML = fs.readFileSync(__dirname + '/../markUp/helpModal/help-footer.html', 'utf8');
    resolve();
  });
}
const loadHelp_tabContent = function(){
  return new Promise(function(resolve, reject){
    quick.innerHTML = fs.readFileSync(__dirname + '/../markUp/helpModal/help-quick.html', 'utf8');
    edit.innerHTML = fs.readFileSync(__dirname + '/../markUp/helpModal/help-edit.html', 'utf8');
    resolve();
  });
}
const LOAD_HTML = function(){
  return new Promise(function(resolve, reject){
    loadHelp_main()
      .then(loadHelp_header)
      .then(loadHelp_body)
      .then(loadHelp_footer)
      .then(loadHelp_tabContent)
      .then(resolve());
  });
}

export { LOAD_HTML };